<template>
  <v-btn
    @click="download"
    color="green"
    class="white--text"
    small
    :loading="downloadLoading"
  >
    {{'action.download_original_photo'| t}}
  </v-btn>
</template>

<script>
import downloadjs from 'downloadjs'
import listActionMixins from '@/components/list/listDataAction/listDataAction.js'
export default {
  mixins: [listActionMixins],
  data: () => ({
    downloadLoading: false,
  }),
  methods: {
    async download() {
      this.$apopup.base({
        title: this.$t('download.confirm'),
        content: `${this.photoName}`,
        applyCallback: () => {
          this.startDownloadFileRequest()
        },
      })
    },
    async startDownloadFileRequest() {
      if(this.downloadLoading == true) return
      this.downloadLoading = true
      try {
        const downloadResult = await this.downloadFileRequest({
          path: this.filePath,
        })
        const data = downloadResult.data
        downloadjs(new Blob([data]), this.sourceName, data.type)
      } catch (error) {
        console.error(error)
      } finally {
        this.downloadLoading = false
      }
    },
  },
  computed: {
    file() {
      return this.row
    },
    sourceName() {
      return this.row.source_name
    },
    photoName() {
      return this.row.name
    },
    filePath() {
      return window.eagleLodash.get(this.row, ['size_list', 'origin', 'path']) || null
    },
    isPreviewType() {
      if(this.file.file_type === 'text/plain') return true
      if(this.file.file_type === 'application/pdf') return true
      if(this.file.file_type === 'application/json') return true
      if(this.file.file_type === 'text/html') return true
      if(new RegExp('image/').test(this.file.file_type)) return true
      return false
    },
    downloadFileRequest() {
      return this.$api.collection.fileApi.download
    },
    fileBaseUrl() {
      return this.$store.getters['base/application'].fileBaseUrl
    },
    fileUrl() {
      if(!this.file) return null
      const path = window.eagleLodash.cloneDeep(this.file.path).substring(1)
      return `${this.fileBaseUrl}${path}`
    },
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>